import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import React from 'react';

import { useListOpportunityStagesByRecordType } from '../../../../OpportunityStages/hooks/useListOpportunityStagesByRecordType';
import { useListLeadStagesByRecordType } from '../../../../LeadStages/hooks/useListLeadStagesByRecordType';
import CustomerPortfolioService from '../../../../../SLA/CustomerPortfolio/service';
import TagClientService from 'views/CRM/Tags/services/TagClientService';
import { useRecordTypes } from 'views/RecordType/hooks/useRecordTypes';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import WhiteListService from '../../../../WhiteList/services/WhiteListService';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import webhookService from 'views/CRM/Webhook/services/webhookService';

const useWebhookForm = (webhook) => {
  const history = useHistory();
  const [tags, setTags] = useState([]);
  const [index, setIndex] = useState('');
  const [title, setTitle] = useState('');
  const [payload, setPayload] = useState('');
  const [entity, setEntity] = useState([]);
  const [whiteList, setWhiteList] = useState([]);
  const { recordTypes } = useRecordTypes('');
  const [recordType, setRecordType] = useState([]);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState('');
  const [selectedWhiteList, setSelectedWhiteList] = useState('');
  const [selectedRecordType, setSelectedRecordType] = useState('');
  const [customerPortfolios, setCustomerPortfolios] = useState([]);
  const { control, handleSubmit, errors, setValue, formState } = useForm();
  const { customFields, getCustomFields, isLoadingCustomFields } =
    useEntityCustomFieldsByRecordType(selectedEntity, selectedRecordType);
  const { getLeadStagesByRecordType, isLoadingLeadStages, leadStages } =
    useListLeadStagesByRecordType();
  const {
    getOpportunityStagesByRecordType,
    opportunityStages,
    isLoadingOpportunityStages
  } = useListOpportunityStagesByRecordType();

  const { isDirty } = formState;

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => {
    history.push('/admin/crm/webhooks');
  };

  useEffect(() => {
    setEntity([
      { id: entitiesName.ACCOUNT, name: 'Conta' },
      { id: entitiesName.CONTACT, name: 'Contato' },
      { id: entitiesName.OPPORTUNITY, name: 'Oportunidade' },
      { id: entitiesName.LEAD, name: 'Lead' }
    ]);
    WhiteListService.getWithPaginationAndSearch(1, true, '')
      .then((response) => {
        const data = response.data.data.result.map((item) => ({
          id: item.id,
          item: `${item.host} ${item.ip_origem}`
        }));
        setWhiteList(data);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            err.message ||
            'Erro ao buscar a lista branca'
        );
      });
  }, []);

  useEffect(() => {
    CustomerPortfolioService.getWithoutPagination()
      .then((response) => {
        const data = response.data.data.content.map((item) => ({
          name: item.name,
          id: item.id
        }));
        setCustomerPortfolios(data);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            err.message ||
            'Erro ao buscar categorias dos clientes'
        );
      });
  }, []);

  useEffect(() => {
    TagClientService.getAll({ showDisabled: false })
      .then((response) => {
        const data = response.data.data.map((item) => ({
          name: item.name,
          id: item.id
        }));
        setTags(data);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || err.message || 'Erro ao buscar as Tags'
        );
      });
  }, []);

  useEffect(() => {
    if (selectedEntity) {
      const selectedRecordTypes = recordTypes?.filter(
        (recordType) => recordType.entity === selectedEntity
      );

      setRecordType([
        ...selectedRecordTypes?.map((recordType) => ({
          id: recordType.id,
          name: recordType.name
        }))
      ]);
    }
  }, [selectedEntity, entity, recordTypes]);

  useEffect(() => {
    setPayload('');
    setIndex('');
    if (selectedEntity && selectedRecordType) {
      getOpportunityStagesByRecordType(selectedRecordType);
      getLeadStagesByRecordType(selectedRecordType);
      getCustomFields();
    }
  }, [
    selectedRecordType,
    selectedEntity,
    getCustomFields,
    getLeadStagesByRecordType,
    getOpportunityStagesByRecordType
  ]);

  const generateExampleValue = (type) => {
    switch (type) {
      case 'TEXT':
        return 'Exemplo de texto';
      case 'NUMERIC':
        return 12345;
      case 'DATE':
        return '01/01/2025';
      case 'CURRENCY':
        return 123.45;
      case 'CPF':
        return '12345678900';
      case 'CNPJ':
        return '12345678900000';
      case 'LINK':
        return 'https://www.exemplo.com';
      case 'HOUR':
        return '12:00:00';
      case 'TELEPHONE':
        return '88912345678';
      case 'LIST':
        return 'Opçao 1';
      case 'MULTIPLE':
        return 'Opçao1;Opçao2';
      default:
        return;
    }
  };

  useEffect(() => {
    if (leadStages && leadStages.length > 0) {
      setIndex((prevIndex) =>
        JSON.stringify(
          {
            ...JSON.parse(prevIndex || '{}'),
            stageId: leadStages.map((stage) => stage.id + ' - ' + stage.name)
          },
          null,
          2
        )
      );
    }
  }, [leadStages]);

  useEffect(() => {
    if (opportunityStages && opportunityStages.length > 0) {
      setIndex((prevIndex) =>
        JSON.stringify(
          {
            ...JSON.parse(prevIndex || '{}'),
            stageId: opportunityStages.map(
              (stage) => stage.id + ' - ' + stage.name
            )
          },
          null,
          2
        )
      );
    }
  }, [opportunityStages]);

  useEffect(() => {
    if (selectedRecordType === '') return;
    if (selectedEntity && selectedRecordType) {
      if (selectedEntity === entitiesName.ACCOUNT) {
        setIndex((prevIndex) =>
          JSON.stringify(
            {
              ...JSON.parse(prevIndex || '{}'),
              customerPortfolioId: customerPortfolios.map(
                (portfolio) => portfolio.id + ' - ' + portfolio.name
              )
            },
            null,
            2
          )
        );
      } else if (selectedEntity === entitiesName.CONTACT) {
        setIndex((prevIndex) =>
          JSON.stringify(
            {
              ...JSON.parse(prevIndex || '{}'),
              tags: tags.map((tag) => tag.id + ' - ' + tag.name)
            },
            null,
            2
          )
        );
      }

      let formattedPayload = {};

      const customFieldsPayload = customFields.reduce((acc, field) => {
        if (!field.recordTypesConfig.isOnlyToShowOnEdit) {
          if (field.options && field.options.length > 0) {
            if (field.type === 'MULTIPLE') {
              acc[field.name] = field.options
                .slice(0, 2)
                .map((option) => option.value)
                .join(';');
            } else {
              acc[field.name] = field.options[0].value;
            }
            setIndex((prevIndex) =>
              JSON.stringify(
                {
                  ...JSON.parse(prevIndex || '{}'),
                  [field.name]: field.options.map((option) => option.value)
                },
                null,
                2
              )
            );
          } else {
            acc[field.name] = generateExampleValue(field.type);
          }
        }
        return acc;
      }, {});

      switch (selectedEntity) {
        case entitiesName.ACCOUNT:
          formattedPayload = {
            name: 'Nome da conta',
            phone: '88912345678',
            ddi: '55',
            customerPortfolioId: 22,
            ...customFieldsPayload
          };
          break;
        case entitiesName.CONTACT:
          formattedPayload = {
            accountId: '37',
            name: 'Nome da contato',
            phone: '88912345678',
            ddi: '55',
            email: 'seu-email@mail.com',
            tags: ['10', '5'],
            ...customFieldsPayload
          };
          break;
        case entitiesName.OPPORTUNITY:
          formattedPayload = {
            accountId: '37',
            title: 'Exemplo de título',
            amount: '123.45',
            expectedClosure: '01/01/2025',
            responsibleLogin: 'login.responsavel',
            stageId: '1',
            ...customFieldsPayload
          };
          break;
        case entitiesName.LEAD:
          formattedPayload = {
            name: 'Nome da Lead',
            phone: '88912345678',
            ddi: '55',
            email: 'seu-email@mail.com',
            responsibleLogin: 'login.responsavel',
            stageId: '1',
            ...customFieldsPayload
          };
          break;
        default:
          formattedPayload = {
            ...customFieldsPayload
          };
          break;
      }

      setPayload(JSON.stringify(formattedPayload, null, 2));
    }
  }, [
    customFields,
    selectedEntity,
    selectedRecordType,
    customerPortfolios,
    tags
  ]);

  const onSubmit = async (data) => {
    setIsSubmiting(true);
    const dataDTO = {
      ...data,
      isEnable: true
    };
    const submitAction = webhook?.webHook?.id
      ? webhookService.update(webhook.webHook.id, dataDTO)
      : webhookService.create(dataDTO);

    submitAction
      .then(() => {
        toast.success(
          `Webhook ${
            webhook?.webHook?.id ? 'atualizado' : 'criado'
          } com sucesso!`
        );
        history.push(`/admin/crm/webhooks`);
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message ||
            err.message ||
            `Erro ao ${webhook?.webHook?.id ? 'atualizar' : 'criar'} Webhook!`
        );
      })
      .finally(() => {
        setIsSubmiting(false);
      });
  };

  return {
    tags,
    isDirty,
    index,
    title,
    payload,
    entity,
    whiteList,
    recordType,
    isSubmiting,
    selectedEntity,
    selectedWhiteList,
    selectedRecordType,
    customerPortfolios,
    control,
    handleSubmit,
    errors,
    setValue,
    formState,
    customFields,
    isLoadingCustomFields,
    isLoadingLeadStages,
    isLoadingOpportunityStages,
    errorFormMessage,
    cancelAction,
    onSubmit,
    setTitle,
    setSelectedEntity,
    setSelectedRecordType,
    setSelectedWhiteList
  };
};

export default useWebhookForm;
